import { render, staticRenderFns } from "./VentaOnlineAgrupadaComponent.vue?vue&type=template&id=95c623c2"
import script from "./VentaOnlineAgrupadaComponent.vue?vue&type=script&lang=js"
export * from "./VentaOnlineAgrupadaComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports